import React, { ReactNode } from "react"
import ClassNames from "classnames"
import { Panel } from "./index"

type DataDescriptionTypeProps = {
  className?: string
  blockClassName?: string
  children?: ReactNode
}

export const DataDescription: React.FC<DataDescriptionTypeProps> = props => {
  return (
    <Panel
      title=""
      className={ClassNames("", props.className)}
      nonePanelHeader={true}
    >
      {props.children}
    </Panel>
  )
}
